import fetcher from '../fetcher';

export type UserGroup = {
	id: string;
	masterUserId: string;
	masterGroupId: string;
	isActive: boolean;
	createdBy: string;
	createdDate: string;
	modifiedBy?: string;
	modifiedDate: string;
};

export type UserGroupPayload = {
	masterUserId: string;
	masterGroupId: string;
	isActive: boolean;
};

export const getUserGroups = () => {
	return fetcher<UserGroup[]>({
		api: '/usergroups/get-all-user-group',
	});
};

export const getUserGroup = (id: string) => {
	return fetcher<UserGroup>({
		api: '/usergroups/get-user-group',
		body: {
			id,
		},
	});
};

export const createUserGroup = (payload: UserGroupPayload) => {
	return fetcher<string>({
		api: '/usergroups/create-user-group',
		body: payload,
	});
};

export const updateUserGroup = (id: string, payload: UserGroupPayload) => {
	return fetcher<string>({
		api: '/usergroups/update-user-group',
		body: {
			id,
			...payload,
		},
	});
};
